import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/pcQrtyCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customPrCorSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getPcQrtyList: ({ searchParams }) => {
		let queryStr = '';
		let srchMm01 = searchParams.srchMm01;
		let srchMm02 = searchParams.srchMm02;

		/*날짜 포멧변환*/
		var strtMm01, endMm01, strtMm02, endMm02;

		if (searchParams.strtMm01) {
			strtMm01 = moment(searchParams.strtMm01).format('YYYYMM');
		} else {
			strtMm01 = '';
		}
		if (searchParams.endMm01) {
			endMm01 = moment(searchParams.endMm01).format('YYYYMM');
		} else {
			endMm01 = '';
		}
		if (searchParams.strtMm02) {
			strtMm02 = moment(searchParams.strtMm02).format('YYYYMM');
		} else {
			strtMm02 = '';
		}
		if (searchParams.endMm02) {
			endMm02 = moment(searchParams.endMm02).format('YYYYMM');
		} else {
			endMm02 = '';
		}
		if (searchParams.srchMm01 !== undefined) {
			queryStr = objectToQuerystring({
				srchMm01: searchParams.srchMm01, //판매월
				srchMm02: searchParams.srchMm02, //조건월
				// plntCd: searchParams.plntCd, //생산공장
				carScn: searchParams.carScn, //차량구분
				pacScn: searchParams.pacScn, //승상구분
				flclSpc: searchParams.flclSpc, //연료전지사양
				phmnCd: searchParams.phmnCd, //현상코드
				ctype: searchParams.cType, //클레임타입
				partG: searchParams.partG, //부품유형
				// customPrCor: searchParams.customPrCor, //생산법인
				// saleNat: searchParams.saleNat, //판매국가
				occuRegn: searchParams.occuRegn, //판매지역
				idxScn: searchParams.idxScn, //지수구분
				opCd: searchParams.opCd, //지수구분
				carTypeNm: searchParams.carTypeNm, //차종유형

				strtTotCst: searchParams.strtTotCst, //비용(from)
				endTotCst: searchParams.endTotCst, //비용(to)

				strtMm01: strtMm01, //strtMm01
				endMm01: endMm01, //endMm01
				strtMm02: strtMm02, //strtMm02
				endMm02: endMm02 //endMm02
			});
		}

		//console.log('값은>>>>', queryStr);
		return client
			.get(`${BASE_URL}/mqy/clma/pcQrty/v1/pcQrtys/srchMm01/${srchMm01}/srchMm02/${srchMm02}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getGraphList: ({ searchParams }) => {
		let queryStr = '';
		if (searchParams.selRowCarCd !== undefined || searchParams.selRowCarCd !== undefined) {
			let stMonth = searchParams.startMonth;
			let stEnd = searchParams.endMonth;

			stMonth = moment(stMonth).startOf('month').format('YYYYMMDD');
			stEnd = moment(stEnd).endOf('month').format('YYYYMMDD');

			queryStr = objectToQuerystring({
				carCd: searchParams.selRowCarCd,
				startMonth: stMonth,
				endMonth: stEnd
			});
		}
		return client
			.get(`${BASE_URL}/sample/v1/graphInfo` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
